import React from "react";

function VibroSifterMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Vibro Sifter Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Vibro Sifter Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png">
          </div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT SECTION */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/31.png"
                        alt="Vibro Sifter Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Vibro Sifter Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Vibro Sifter Machine is used for sieving, grading, and 
                      separating powders in pharmaceutical, chemical, and food 
                      industries. Its multi-screen design ensures high throughput 
                      and particle size accuracy.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Featuring vibration-based separation, stainless steel 
                      contact parts, and quick sieve change mechanism, this 
                      machine delivers smooth and efficient sifting performance.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/31.png"
                            alt="Vibro Sifter Side View"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/32.png"
                            alt="Vibro Sifter Closeup"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-VS-20</td>
                          <td>DPM-VS-30</td>
                          <td>DPM-VS-36</td>
                        </tr>

                        <tr>
                          <td>Sieve Diameter</td>
                          <td>20 inch</td>
                          <td>30 inch</td>
                          <td>36 inch</td>
                        </tr>

                        <tr>
                          <td>Production Capacity</td>
                          <td>50–100 kg/hr</td>
                          <td>100–250 kg/hr</td>
                          <td>200–350 kg/hr</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>0.5 HP</td>
                          <td>1 HP</td>
                          <td>1.5 HP</td>
                        </tr>

                        <tr>
                          <td>No. of Screens</td>
                          <td>1–2</td>
                          <td>1–3</td>
                          <td>2–3</td>
                        </tr>

                        <tr>
                          <td>Material of Construction</td>
                          <td colSpan="3">SS 304 / SS 316 Contact Parts</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>600 × 600 × 750 mm</td>
                          <td>750 × 750 × 900 mm</td>
                          <td>900 × 900 × 1050 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>85 kg</td>
                          <td>120 kg</td>
                          <td>160 kg</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>

                    <ul>
                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/dust-extractor">
                          Dust Extractor Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>
                    </ul>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default VibroSifterMachine;
